import type { SavedPaymentMethod, SavedPaymentMethodContent } from 'src/app/pages/promote/shared/types';
import type { PaymentType } from 'src/app/shared/utils/payments';

export const resolveSavedPaymentMethodContent = (
	savedPaymentMethods: SavedPaymentMethod[],
	paymentMethods: PaymentType[],
): SavedPaymentMethodContent[] => {
	return savedPaymentMethods
		.map((method) => {
			if (method.__typename === 'PaymentMethodCreditCard') {
				if (!method.settings.supportsOneTimeCharges) {
					if (method.walletType === 'apple_pay' && paymentMethods.includes('applePay')) {
						return {
							type: 'applePay' as PaymentType,
						};
					}
					if (method.walletType === 'google_pay' && paymentMethods.includes('googlePay')) {
						return {
							type: 'googlePay' as PaymentType,
						};
					}
					return null;
				}
				return {
					type: method.type,
					brand: method.brand,
					detail: method.last4,
				};
			}
			if (method.__typename === 'PaymentMethodSepa') {
				return {
					type: method.type,
					detail: method.last4,
				};
			}
			return {
				type: method.type,
			};
		})
		.filter((method) => method !== null);
};
